import { JsEnv } from "../../../core/models/js_env";
import { KeywordSuggestRepository } from "../../../core/repositories/keyword_suggest_repository";
import { TypedEvent } from "../../../core/typed_event";
import { HistorySuggest } from "../models/history_suggest";
import { KeywordDetail } from "../models/keyword_detail";
import { KeywordDetailJsEnv } from "../models/keyword_detail_js_env";
import { Suggest } from "../models/suggest";
import { SearchwordSuggestionContainer } from "../views/pc/searchword_suggestion_container";

export class SearchwordSuggestionAction {
  static readonly UPDATE_EVENT = new TypedEvent<KeywordDetailJsEnv>();
  private static state: KeywordDetail;
  private static keywordSuggestRepository: KeywordSuggestRepository;

  static init(env: JsEnv) {
    this.state = new KeywordDetail(env.PAGE);
    this.keywordSuggestRepository = new KeywordSuggestRepository();
    return new SearchwordSuggestionContainer();
  }

  static async updateSuggest(searchword: string) {
    this.state.clearSuggest();
    if (searchword === '') {
      const result = await this.keywordSuggestRepository.getKeywordHistorySuggest();
      this.state.setHistorySuggest(new HistorySuggest(result));
    } else {
      const result = await this.keywordSuggestRepository.getKeywordSuggest(searchword);
      this.state.setSuggest(new Suggest(result));
    }
    this.UPDATE_EVENT.trigger(this.state.getModel());
  }
}
